import React from 'react';
import {
  Flex,
} from 'web-styled';

import * as S from './styled';

export type InputProps = {
  flex: string,
  width?: string,
  spacing?: number,
  label?: string,
  color: string,
  form: any,
  field: any,
  margin?: string,
  className?: string,
  errorStyle?: any,
  Element: React.ReactNode,
};

const FormElementField = ({
  label,
  field,
  form: {
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
  },
  flex,
  width,
  spacing,
  color,
  Element,
  margin,
  errorStyle,
  className,
}: InputProps) => {
  const error = (touched[field.name] && errors[field.name]);

  return (
    <Flex
      column
      width={width}
      spacing={spacing}
      flex={flex}
      margin={margin}
      className={className}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
        >
          {label}
        </S.Label>
      )}
      <S.FormElementContainer
        hasError={error}
      >
        <Element
          className="card-element"
          onChange={(e) => {
            setFieldValue(field.name, e.complete);
          }}
          onBlur={() => {
            setFieldTouched(field.name);
          }}
        />
      </S.FormElementContainer>
      {error && (
        <S.Error style={errorStyle}>
          {error}
        </S.Error>
      )}
    </Flex>
  );
};

FormElementField.defaultProps = {
  label: null,
  spacing: 10,
  width: '100%',
  margin: '0',
  className: '',
  errorStyle: {},
};

export default FormElementField;
